const URL_PROTOCOL_PATTERN = /^[a-z][a-z0-9+.-]*:\/\//i;
const HTTP_URL_PROTOCOL_PATTERN = /^https?:\/\//i;

export function normalizeOptionalCompanyWebsiteUrl(
  value: string | null | undefined,
): string | undefined {
  const trimmedValue = value?.trim() ?? "";
  if (!trimmedValue) {
    return undefined;
  }

  if (URL_PROTOCOL_PATTERN.test(trimmedValue) && !HTTP_URL_PROTOCOL_PATTERN.test(trimmedValue)) {
    return undefined;
  }

  const url = HTTP_URL_PROTOCOL_PATTERN.test(trimmedValue)
    ? trimmedValue
    : `https://${trimmedValue}`;

  try {
    const parsedUrl = new URL(url);
    if (!parsedUrl.hostname || !HTTP_URL_PROTOCOL_PATTERN.test(url)) {
      return undefined;
    }
    return url;
  } catch {
    return undefined;
  }
}

export function isOptionalCompanyWebsiteUrl(value: string | null | undefined): boolean {
  const trimmedValue = value?.trim() ?? "";
  return !trimmedValue || normalizeOptionalCompanyWebsiteUrl(trimmedValue) !== undefined;
}
